export enum BehavioralHealthSpecialtyNames {
  PSY_NURSE_PRACTITIONER_FAMILY = 'Psych Nurse Practitioner, Family'
}
